// extracted by mini-css-extract-plugin
export default {"productDescription":"naa-z","featuredDescription":"oaa-z","description":"paa-z","more":"qaa-z","descriptionSku":"raa-z"};